import { createRequestActions } from "common/helpers/action";

export const initCpKkmAdd = createRequestActions("CP.KKM.ADD.INIT");
export const sendCpKkmAdd = createRequestActions("CP.KKM.ADD.SEND");
